import React from "react";
import Slider from "react-slick";
import arrow from "../images/arrow.png";
import joker from "../images/joker.png";
import dora from "../images/dora.png";
import after from "../images/after.png";
import { Component } from "react";

class UpcommingBio extends Component {
  constructor() {
    super();
    this.state = {
      upcomingBioData: [
        // {
        //   thumbnailUrl: joker,
        //   title: "Sapna Vardi Ka",
        //   releaseDate: "12/12/2021"
        // },
        // {
        //   thumbnailUrl: joker,
        //   title: "Sapna Vardi Ka",
        //   releaseDate: "12/12/2021"
        // },
        // {
        //   thumbnailUrl: joker,
        //   title: "Sapna Vardi Ka",
        //   releaseDate: "12/12/2021"
        // },

      ],

      slideCount: 3,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.upcomingBioData !== this.props.upcomingBioData) {
      this.setState({
        upcomingBioData: nextProps.upcomingBioData
      },
        () => {
          this.setState(
            {
              slideCount: this.state.upcomingBioData.length > 3 ? 3 : this.state.upcomingBioData.length
            }, () => console.log(this.state.slideCount)
          )
        }
      )
    }
  }
  render() {
    const { upcomingBioData, slideCount } = this.state
    console.log(upcomingBioData);
    let settings = {};
    if (window.screen.width < 700) {
      settings = {
        dots: false,
        // lazyLoad: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1.5,
        slidesToScroll: 1.5,
        arrows: false,
        // centerMode: true,
      };
    } else {
      settings = {
        dots: false,
        // lazyLoad: true,
        infinite: true,
        speed: 500,
        slidesToShow: upcomingBioData && upcomingBioData.length > 3 ? 4 : upcomingBioData.length,
        slidesToScroll: upcomingBioData && upcomingBioData.length > 3 ? 4 : upcomingBioData.length,
        arrows: false,
        // centerMode: true,
      };
    }


    return (
      upcomingBioData && upcomingBioData.length > 0 ?
        <div className="UpcommingBio">
          <div className="UpcommingBio__Head">Upcoming Biographies</div>
          <div className="UpcommingBio__Content">
            <Slider {...settings} ref={(c) => (this.slider = c)}>
              {upcomingBioData && upcomingBioData.map((data, index) => {
                return (
                  <div className="UpcommingBio__Content--Details" key={index}>
                    <div className="UpcommingBio__Content--Details__Container">
                      <img
                        className="UpcommingBio__Content--Details__Container--Img"
                        src={data.thumbnailUrl}
                        alt=""
                      />
                      <div className="UpcommingBio__Content--Details__Container__Hidden">
                        <div className="UpcommingBio__Content--Details__Container__Hidden--Title">{data.title}</div>
                        <div className="UpcommingBio__Content--Details__Container__Hidden--Biography">Biography</div>
                        <div className="UpcommingBio__Content--Details__Container__Hidden--Releasing">Releasing</div>
                        <div className="UpcommingBio__Content--Details__Container__Hidden--Date">{data.releaseDate}</div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </Slider>
            {
              upcomingBioData && upcomingBioData.length > 4 && <div className="UpcommingBio__Content--ArrowDiv">
                <img
                  className="UpcommingBio__Content--ArrowDiv__Right"
                  src={arrow}
                  alt=""
                  onClick={() => {
                    this.slider.slickPrev();
                  }}
                />
                <img
                  className="UpcommingBio__Content--ArrowDiv__Left"
                  src={arrow}
                  alt=""
                  onClick={() => {
                    this.slider.slickNext();
                  }}
                />
              </div>
            }

          </div>
        </div> : ""
    );
  }
}

export default UpcommingBio;
